
const invoicesLengthMessage = (invoicesArr, filters, windowWidth) => {
    const invoicesLength = invoicesArr.length;
    const isMobile = windowWidth <= 768;
    const { status, user } = filters;
    let filterDescription = 'total invoices';

    if (status !== 'all' && user !== 'all') {
        filterDescription = `${status} invoices from ${user}`;
    } else if (status !== 'all') {
        filterDescription = `${status} invoices`;
    } else if (user !== 'all') {
        filterDescription = `invoices from ${user}`;
    }

    if (invoicesLength === 0) {
        return `No ${filterDescription}`;
    } else if (invoicesLength === 1) {
        if (isMobile) {
            return `1 invoice`;
        } else {
            return `There is 1 invoice`;
        }
    } else if (invoicesLength > 1) {
        if (isMobile) {
            return `${invoicesLength} invoices`;
        } else {
            return `There are ${invoicesLength} ${filterDescription}`;
        }
    }
};

export default invoicesLengthMessage;
